import { render, staticRenderFns } from "./ImageDetail.vue?vue&type=template&id=5d84ac60&scoped=true&"
import script from "./ImageDetail.vue?vue&type=script&lang=js&"
export * from "./ImageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d84ac60",
  null
  
)

export default component.exports